{
  "DatePicker": {
    "toggleIncludeHoursRich": "<p>指定此日期范围的确切开始/结束时间</p>按 <kbd>,</kbd> 切换",
    "toggleIncludeHours": "指定此日期范围的确切开始/结束时间",
    "toggleIncludeHoursHint": "按下",
    "pressEnterToApply": "按 <kbd><enter/></kbd> 应用",
    "presetsLabel": "日期选择器预设",
    "presetsHeader": "预设",
    "range": {
      "lastWeek": "最近一周",
      "currentWeek": "当前一周",
      "lastMonth": "最近一个月",
      "currentMonth": "当前一个月",
      "last3Months": "最近三个月",
      "current3Months": "当前三个月",
      "lastYear": "去年",
      "currentYear": "今年",
      "allTime": "所有时间"
    }
  },
  "Select": {
    "clear": "清除选择",
    "emptyPlaceholder": "请选择"
  },
  "TernaryToggle": {
    "yes": "是",
    "no": "否",
    "notSet": "未设置",
    "emptyValue": "无"
  },
  "Pagination": {
    "page": "第 {{current}} / {{total}} 页",
    "pageFraction": "{{current}} / {{total}}",
    "navigation": "分页",
    "previousPage": "上一页",
    "nextPage": "下一页",
    "jumpInput": "页码",
    "jumpPlaceholder": "1 - {{total}}",
    "jumpAction": "前往"
  },
  "MediaDialog": {
    "close": "关闭",
    "previous": "上一个",
    "next": "下一个",
    "counter": "第 {{index}} 个，共 {{count}} 个",
    "thumbnails": "缩略图",
    "loading": "加载中"
  }
}
